import styled from 'styled-components';

export const UiHomeSchoolForm = styled.div`
	display: block;

	& p {
		margin: 3px 0 0;
	}
`;
